import React from 'react';
import styles from './Chatbot.module.scss';
import { ReactComponent as ChatDotsIcon } from '../assets/svgs/chat-dots.svg';

interface ChatButtonProps {
    showTooltip: boolean;
    setIsChatVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const ChatButton: React.FC<ChatButtonProps> = ({ showTooltip, setIsChatVisible }) => {
    return (
        <div className={styles.chatButtonContainer}>
            {showTooltip && (
                <div className={styles.tooltip}>
                    <span className={styles.tooltipArrow}></span>
                    Klicken Sie hier, um mit dem Support zu chatten!
                </div>
            )}
            <button onClick={() => setIsChatVisible(true)} className={styles.chatButton}>
                <ChatDotsIcon className={styles.chatBotIcon} />
            </button>
        </div>
    );
};

export default ChatButton;
